export default __webpack_public_path__ + "static/media/AdamLekin.ed72a009.jpg";